import gql from 'graphql-tag'

export default gql`mutation removeProjectClientInvoice($invoice_id: Int!, $project_id: String!) {
    removeProjectClientInvoice(invoice_id: $invoice_id, project_id: $project_id) @client
}`